module.exports = __webpack_public_path__ + "img/4.e39d9cd1.jpg";